import React from "react";

export default function Pagination({
  page,
  pageSize,
  total,
  onPageChange,
  onPageSizeChange,
}) {
  const pageCount = Math.max(1, Math.ceil(total / pageSize));


  return (
    <div className="pagination">
      <div className="pg-left">
        <span className="muted">Showing</span>
        <select
          className="pg-size"
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          aria-label="Rows per page"
          title="Rows per page"
        >
          <option value={10}>10</option>
          <option value={25}>25</option>
          <option value={50}>50</option>
        </select>
        <span className="muted">out of <b>{pageCount}</b></span>
      </div>

      <div className="pg-right">
        <button
          type="button"
          className="pg-btn"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
          aria-label="Previous page"
        >
          ‹
        </button>

        <span className="pg-num is-active" aria-current="page">{page}</span>

        <button
          type="button"
          className="pg-btn"
          disabled={page >= pageCount}
          onClick={() => onPageChange(page + 1)}
          aria-label="Next page"
        >
          ›
        </button>
      </div>
    </div>
  );
}
